import React from "react";
import BannerImages from "../../Common/BannerImages";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import ShopPagePreview from "./ShopPagePreview";
import { templateActions } from "../../templateStore";
import { useTemplateData } from "@constants/template";
import { useSelector } from "react-redux";

const WebsiteShoPage = React.memo(function WebsiteShoPage({
    selectedRows,
}: any) {
    const { t } = useTranslation();
    const { getNestedValue } = useTemplateData();

    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);
    const [isReady, setIsReady] = React.useState(false);
    let schema: any = useSelector(
        (state: any) => state.global.entityDetails.franchise_schema
    );
    const boutique = schema + "_" + selectedRows[0].shopId;

    const popupImagePathDesktop = React.useMemo(
        () => [
            "SiteWeb",
            "ChoixBoutique",
            "Boutique",
            boutique,
            "Popup",
            "Image",
            "Desktop",
        ],
        [boutique]
    );

    const popupImagePathMobile = React.useMemo(
        () => [
            "SiteWeb",
            "ChoixBoutique",
            "Boutique",
            boutique,
            "Popup",
            "Image",
            "Mobile",
        ],
        [boutique]
    );

    const popupLogoPathDesktop = React.useMemo(
        () => [
            "SiteWeb",
            "ChoixBoutique",
            "Boutique",
            boutique,
            "Logo",
            "Desktop",
        ],
        [boutique]
    );

    const popupLogoPathMobile = React.useMemo(
        () => [
            "SiteWeb",
            "ChoixBoutique",
            "Boutique",
            boutique,
            "Logo",
            "Mobile",
        ],
        [boutique]
    );

    const [phoneNumber, setPhoneNumber] = React.useState<any>("");

    React.useEffect(() => {
        const ensureAllPaths = async () => {
            await templateActions.ensurePathExists(
                [
                    "SiteWeb",
                    "ChoixBoutique",
                    "Boutique",
                    boutique,
                    "Popup",
                    "PhoneNumber",
                ],
                ""
            );

            await templateActions.ensurePathExists(
                [
                    "SiteWeb",
                    "ChoixBoutique",
                    "Boutique",
                    boutique,
                    "Popup",
                    "Image",
                    "Desktop",
                ],
                { Url: "", Name: "", Type: "", Extenxion: "" }
            );

            await templateActions.ensurePathExists(
                [
                    "SiteWeb",
                    "ChoixBoutique",
                    "Boutique",
                    boutique,
                    "Popup",
                    "Image",
                    "Mobile",
                ],
                { Url: "", Name: "", Type: "", Extenxion: "" }
            );

            await templateActions.ensurePathExists(
                [
                    "SiteWeb",
                    "ChoixBoutique",
                    "Boutique",
                    boutique,
                    "Logo",
                    "Desktop",
                ],
                { Url: "", Name: "", Type: "", Extenxion: "" }
            );

            await templateActions.ensurePathExists(
                [
                    "SiteWeb",
                    "ChoixBoutique",
                    "Boutique",
                    boutique,
                    "Logo",
                    "Mobile",
                ],
                { Url: "", Name: "", Type: "", Extenxion: "" }
            );

            const phoneValue = getNestedValue([
                "SiteWeb",
                "ChoixBoutique",
                "Boutique",
                boutique,
                "Popup",
                "PhoneNumber",
            ]);
            setPhoneNumber(phoneValue ?? "");

            setIsReady(true);
        };

        ensureAllPaths();
    }, [boutique, getNestedValue]);

    if (!isReady) return null;

    const tabs = [
        {
            title: t("Shop information pop-up"),
            content: (
                <div className="banner-container">
                    <section className="text-section">
                        <p className="image-title">Logo</p>
                        <div className="banner-images">
                            <BannerImages
                                dataPath={popupLogoPathDesktop}
                                title="Desktop"
                                size="300*300 (png,jpg,jpeg ou webp)"
                            />
                            <BannerImages
                                dataPath={popupLogoPathMobile}
                                title="Mobile"
                                size="300*300 (png,jpg,jpeg ou webp)"
                            />
                        </div>
                        <p className="image-title mt-4">
                            {t("Store Information Image Pop-up")}
                        </p>
                        <div className="banner-images">
                            <BannerImages
                                dataPath={popupImagePathDesktop}
                                title="Desktop"
                                size="706*621 (png,jpg,jpeg ou webp)"
                            />
                            <BannerImages
                                dataPath={popupImagePathMobile}
                                title="Mobile"
                                size="706*621 (png,jpg,jpeg ou webp)"
                            />
                        </div>
                        <p className="image-title mt-4">{t("Connexion")}</p>
                        <div className="image-upload-section mt-2">
                            <span
                                style={{
                                    pointerEvents: "none",
                                    cursor: "default",
                                    fontWeight: "bold",
                                }}
                            >
                                {t("Phone number")}
                            </span>
                            <input
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                style={{ width: "50%" }}
                                maxLength={15}
                                className="form-control  epb_inp_timeASmr-2"
                                onChange={(e: any) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        setPhoneNumber(value);
                                        templateActions.updateTemplate(
                                            [
                                                "template",
                                                "SiteWeb",
                                                "ChoixBoutique",
                                                "Boutique",
                                                boutique,
                                                "Popup",
                                                "PhoneNumber",
                                            ],
                                            value
                                        );
                                    }
                                }}
                                value={phoneNumber}
                            />
                        </div>
                    </section>
                </div>
            ),
            customClassName: "",
        },
    ];

    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
        <div className="d-flex justify-content-between">
            <div style={{ width: "50%" }}>
                <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                    <Nav
                        tabs
                        style={{
                            backgroundColor: "white",
                            width: "50px",
                            display: "grid",
                            gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                            border: "unset",
                        }}
                    >
                        {tabs.map((element, index) => (
                            <NavItem
                                key={index}
                                className={classNames(
                                    "pb-1",
                                    "d-flex align-items-center text-nowrap",
                                    {
                                        "disable-nav-item__clz":
                                            activeTab !== index,
                                    },
                                    element.customClassName
                                )}
                                style={{
                                    cursor: "pointer",
                                    borderBottom:
                                        activeTab === index
                                            ? `${mainColor} 3px solid`
                                            : "",
                                }}
                            >
                                <NavLink
                                    className={classNames("text-dark w-100", {
                                        "active customer-account-menu-nav-link-active__clz":
                                            activeTab === index,
                                        "customer-account-menu-nav-link-disable__clz":
                                            activeTab !== index,
                                    })}
                                    onClick={() => toggleNav(index)}
                                >
                                    <span
                                        className="px-2"
                                        style={{
                                            font:
                                                "normal normal 600 20px/27px Segoe UI",
                                        }}
                                    >
                                        {element.title}
                                    </span>
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </div>
                <TabContent activeTab={activeTab} className="h-100">
                    {tabs.map((element, index) => (
                        <TabPane
                            tabId={index}
                            key={index}
                            style={{ height: "90%" }}
                        >
                            {element.content}
                        </TabPane>
                    ))}
                </TabContent>
            </div>

            <div style={{ width: "50%" }}>
                <ShopPagePreview
                    selectedRows={selectedRows}
                    imagePath={popupImagePathDesktop}
                    logoPath={popupLogoPathDesktop}
                    PhoneNumber={phoneNumber}
                />
            </div>
        </div>
    );
});

export default WebsiteShoPage;
